import { render } from "./Vision.vue?vue&type=template&id=0c32ec16"
import script from "./Vision.vue?vue&type=script&lang=js"
export * from "./Vision.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Keith\\source\\michaelslyfescheme\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__